import { useEffect } from 'react';

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

export const useGoogleTag = (measurementId: string) => {
  useEffect(() => {
    if (!measurementId) return;

    // Google Tag Manager (gtag.js) initialization
    if (!document.getElementById('google-tag-manager')) {
      const script = document.createElement('script');
      script.id = 'google-tag-manager';
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
      document.head.appendChild(script);

      window.dataLayer = window.dataLayer || [];
      window.gtag = function () {
        // eslint-disable-next-line prefer-rest-params
        window.dataLayer.push(arguments);
      };
      window.gtag('js', new Date());
      window.gtag('config', measurementId);
    }
  }, [measurementId]);
};
